
import { memo, useEffect, useMemo, useRef, useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(ArcElement, Tooltip, Legend);
const AnalysisDonutChart = ({ arrSeries, sectorData, stockData }) => {


    const chartRef = useRef(null);
    const [sectorInfo, setSectorInfo] = useState({});
    // const [options, setOptions] = useState({});
    const [middleData, setMiddleData] = useState([]);
    const [middleLabel, setMiddleLabel] = useState([]);
    const [outerData, setOuterData] = useState([]);
    const [outerLabel, setOuterLabel] = useState([]);
    const [previousOuterValues, setPreviousOuterValues] = useState({});
    const [isDrilledDown, setIsDrilledDown] = useState(false);
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: []
    });

    const originalState = useMemo(() => {
        return {
            labels: [...middleLabel, ...outerLabel],
            datasets: [
                {
                    label: 'Outer Segment',
                    data: outerData,
                    backgroundColor: ['#5f87c2', '#2862c3', '#f1cb8d', '#6ea9e1'],
                    borderColor: 'white',
                    borderWidth: 2,
                },
                {
                    label: 'Middle Segment',
                    data: middleData,
                    backgroundColor: ['#5f87c2', '#2862c3', '#f1cb8d', '#6ea9e1'],
                    borderColor: 'white',
                    borderWidth: 2,
                },
                {
                    label: 'Inner Segment',
                    data: [100],
                    backgroundColor: ['#4BC0C0'],
                    borderColor: 'white',
                    borderWidth: 2,
                },
            ]
        }
    }, [middleLabel, outerLabel, outerData, middleData]);

    useEffect(() => {
        if (sectorData?.length && stockData?.length) {
            let arrMdata = [];
            let arrMlabel = [];
            let arrOdata = [];
            let arrOlabel = [];


            sectorData.forEach(eachSector => {
                arrMlabel.push(eachSector.sector);
                arrMdata.push(eachSector.sectorPercentage);
            });
            stockData.forEach(eachSector => {
                arrOdata.push(eachSector.percentage);
                arrOlabel.push(eachSector.stock);
            });
            setMiddleData(arrMdata);
            setMiddleLabel(arrMlabel);
            setOuterData(arrOdata);
            setOuterLabel(arrOlabel);


            let arrStockData = arrSeries?.find(eachSeries => eachSeries.labelKey == 'stock');
            let obj = {};
            stockData.forEach(eachStock => {
                if (Object.keys(obj).includes(eachStock.sector)) {
                    obj[eachStock.sector].labels.push(eachStock.stock);
                    obj[eachStock.sector].values.push(eachStock.percentage);
                }
                else {
                    obj[eachStock.sector] = {
                        labels: [eachStock.stock],
                        values: [eachStock.percentage]
                    };
                }
            });
            setSectorInfo(obj);
            const data = {
                labels: [...arrMlabel, ...arrOlabel],
                datasets: [
                    {
                        label: 'Outer Segment',
                        data: arrOdata,
                        backgroundColor: ['#5f87c2', '#2862c3', '#f1cb8d', '#6ea9e1'],
                        borderColor: 'white',
                        borderWidth: 2
                    },
                    {
                        label: 'Middle Segment',
                        data: arrMdata,
                        backgroundColor: ['#5f87c2', '#2862c3', '#f1cb8d', '#6ea9e1'],
                        borderColor: 'white',
                        borderWidth: 2,
                    },
                    {
                        label: 'Inner Segment',
                        data: [100],
                        backgroundColor: ['#4BC0C0'],
                        borderColor: 'white',
                        borderWidth: 2,
                    },
                ]
            };
            if (isDrilledDown === false) {
                setChartData(data);
            }
        }
    }, [sectorData, stockData]);

    const handleClick = (event) => {
        const chart = chartRef.current;
        const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true });
        const clickedElement = elements[0];
        const { datasetIndex, index } = clickedElement;
        if (datasetIndex == 1 && isDrilledDown) {
            setChartData(originalState);
            setIsDrilledDown(false);
        }
        else if (datasetIndex == 1 && !isDrilledDown) {
            const label = chartData.labels[index];
            const value = chartData.datasets[datasetIndex].data[index];
            const outerLabels = sectorInfo[label].labels;
            const outerDataValues = sectorInfo[label].values;
            setPreviousOuterValues({ labels: outerLabels, values: outerDataValues });
            setChartData({
                labels: [`${label}`, ...outerLabels],
                datasets: [
                    {
                        label: 'Outer Segment',
                        data: outerDataValues,
                        backgroundColor: ['#5f87c2', '#2862c3', '#f1cb8d', '#6ea9e1'],
                        borderWidth: 1,
                    },
                    {
                        label: 'Inner Segment',
                        data: [value],
                        backgroundColor: ['#4BC0C0'],
                        borderWidth: 1,
                    }

                ]
            });
            setIsDrilledDown(true);
        }
        chart.update()
    };
    const options = {
        responsive: true,
        onClick: handleClick,
        plugins: {
            legend: {
                display: false,
                position: 'top',
            },

            tooltip: {
                displayColors: false,
                callbacks: {
                    title: () => {
                        return '';
                    },
                    label: (tooltipItem) => {
                        const { dataset, dataIndex } = tooltipItem;
                        const value = dataset.data[dataIndex];
                        const totalValue = dataset.data.reduce((sum, value) => sum + value);
                        let label;
                        if (chartData.datasets.length == 3) {
                            if (dataset.label == 'Inner Segment') {
                                label = 'Equitites';
                            }
                            else if (dataset.label == 'Middle Segment') {
                                label = chartData.labels[dataIndex];
                            }
                            else if (dataset.label == 'Outer Segment') {
                                const middleCount = middleData.length;
                                label = chartData.labels[dataIndex + middleCount];
                            }
                            return `${label} (${value.toFixed(2)})%`;
                        }
                        else {

                            let nModifiedValue;
                            if (dataset.label == 'Inner Segment') {
                                label = chartData.labels[dataIndex];
                                nModifiedValue = 100
                            }
                            else if (dataset.label == 'Outer Segment') {
                                const middleCount = middleData.length;
                                label = chartData.labels[dataIndex + 1];
                                let subPercentage = ((value * 1) / Number(totalValue)) * 100;
                                if (isNaN(subPercentage)) {
                                    nModifiedValue = 100;
                                } else {
                                    nModifiedValue = subPercentage;
                                }
                            }
                            return `${label} (${nModifiedValue.toFixed(2)})%`;
                        }
                    },

                }
            },
            datalabels: {
                clip: true,
                color: 'black',
                align: 'center',
                font: {
                    size: 11
                },
                display: (ctx) => {
                    const dataset = ctx.dataset;
                    const total = dataset.data.reduce((sum, value) => sum + value, 0);
                    const value = ctx.dataset.data[ctx.dataIndex];
                    const percentage = (value / total) * 100;
                    return percentage > 5;
                },
                formatter: (value, context) => {
                    const chart = context?.chart;
                    const datasetMeta = chart.getDatasetMeta(context.datasetIndex);
                    // const element = datasetMeta?.data[context.dataIndex];  // Hari K:13-01-2025 need to remove later
                    // const angle = (element?.endAngle - element?.startAngle) * (180 / Math.PI);
                    const dataValue = context.chart.data.datasets[context.datasetIndex].data[context.dataIndex] || 0;
                    // const segmentRadius = element?.outerRadius - element?.innerRadius;
                    // const maxTextWidth = segmentRadius * Math.sin(angle / 2);
                    // const textwidth = context?.chart?.context?.measureText(`${context?.chart.data.labels[context.dataIndex]} (${dataValue.toFixed(2)}%)`).width;
                    const datasetLabel = context.dataset.label;
                    const segmentIndex = context.dataIndex;
                    const totalMiddleLabels = middleLabel.length;

                    const dataset = context.dataset;
                    const totalValue = dataset.data.reduce((sum, value) => sum + value);

                    const element = context.chart.getDatasetMeta(context.datasetIndex).data[context.dataIndex];
                    if (chartData.datasets.length == 3) {
                        if (datasetLabel == 'Inner Segment') {
                            return 'Equities';
                        }
                        const totalSegments = context.chart.data.labels.length;
                        if (datasetLabel == 'Middle Segment') {
                            const textWidth = context?.chart?.ctx?.measureText(`${context?.chart?.data?.labels[segmentIndex]?.substring(0, 2)}..(${value.toFixed(2)}%)`).width; // Display label only if it fits
                            //  if ( textWidth<=sliceWidth) {      // Hari K:13-01-2025 need to remove later                       
                            return `${context?.chart?.data?.labels[segmentIndex]?.substring(0, 5)}\n(${value.toFixed(2)}%)`;
                            //              }else {
                            //             return '';
                            //  }
                        }
                        if (datasetLabel == 'Outer Segment') { // Hari K:13-01-2025 need to remove later
                            // const textWidth = context?.chart?.ctx?.measureText(`${context?.chart?.data?.labels[segmentIndex + totalMiddleLabels]?.substring(0, 2)}..(${value.toFixed(2)}%)`).width; // Display label only if it fits
                            //  if ( textWidth<=sliceWidth) {                           
                            return `${context?.chart?.data?.labels[segmentIndex + totalMiddleLabels]?.substring(0, 5)}\n(${value.toFixed(2)}%)`;
                            //   }else {
                            //     return '';
                            //                       }      
                        }
                    }
                    else {
                        const totalSegments = context.chart.data.labels.length;
                        if (datasetLabel == 'Inner Segment') { // Hari K:13-01-2025 need to remove later
                            //    const textWidth = context?.chart?.ctx?.measureText(`${context?.chart?.data?.labels[segmentIndex]?.substring(0, 2)}..(${value.toFixed(2)}%)`).width; // Display label only if it fits
                            //      if ( textWidth<=sliceWidth) {  
                            return `${context?.chart?.data?.labels[segmentIndex]?.substring(0, 5)}\n(${100.00}%)`;
                            //   }else {
                            //     return '';
                        }

                        if (datasetLabel == 'Outer Segment') {
                            const textWidth = context?.chart?.ctx?.measureText(`${context?.chart?.data?.labels[segmentIndex + 1]?.substring(0, 2)}..(${value.toFixed(2)}%)`).width; // Display label only if it fits
                            const subPercentage = ((value * 1) / Number(totalValue)) * 100;
                            let nModifiedValue;
                            if (isNaN(subPercentage)) {
                                nModifiedValue = 100;
                            } else {
                                nModifiedValue = subPercentage;
                            }
                            //  if ( textWidth<=sliceWidth) {  // Hari K:13-01-2025 need to remove later
                            //     if (`${context?.chart?.data?.labels[segmentIndex + 1]}`.length > 2) {
                            return `${context?.chart?.data?.labels[segmentIndex + 1]?.substring(0, 5)}\n(${nModifiedValue.toFixed(2)}%)`;
                            //         }
                            //     }else {
                            //         return '';
                            // }
                        }
                    }

                }
            }
        },
    }


    return <Pie ref={chartRef} data={chartData} options={options} plugins={[ChartDataLabels]} />;
};


export default memo(AnalysisDonutChart);;